import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudioPlaybackHeadphonesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 124,
	height: 111,
	viewBox: "0 0 124 111",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8496_7663)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M62.0004 0C27.9457 0 0 28.0951 0 62.6295V92.1016C0 98.196 4.88884 103.154 10.8984 103.154H14.531V66.3133H10.8984C9.61862 66.3133 8.40727 66.5792 7.26588 66.9921V62.6295C7.26588 32.1567 31.9516 7.36817 62.0004 7.36817C92.0484 7.36817 116.734 32.1567 116.734 62.6295V66.9921C115.593 66.5792 114.381 66.3133 113.102 66.3133H109.469V103.154H113.102C119.111 103.154 124 98.196 124 92.1016V62.6295C124 28.0951 96.0543 0 62.0004 0Z",
				fill: "#D0D0D0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.5713 58.9443H24.9387C20.9255 58.9443 17.6729 62.2428 17.6729 66.3127V103.153C17.6729 107.222 20.9255 110.522 24.9387 110.522H28.5713C30.5779 110.522 32.2039 108.872 32.2039 106.837V62.6282C32.2039 60.594 30.5779 58.9443 28.5713 58.9443Z",
				fill: "#D0D0D0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M99.3147 58.9443H95.6814C93.6755 58.9443 92.0488 60.594 92.0488 62.6282V106.837C92.0488 108.872 93.6755 110.522 95.6814 110.522H99.3147C103.327 110.522 106.58 107.222 106.58 103.153V66.3127C106.58 62.2428 103.327 58.9443 99.3147 58.9443Z",
				fill: "#D0D0D0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8496_7663",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 124,
			height: 110.522,
			fill: "white"
		})
	}) })]
});
export default SvgAudioPlaybackHeadphonesIcon;
